import { BEACH_ACTIVITIES, BEACH_NEARBY_TAGS } from "@/data/beaches";
import { WATER_LEVELS } from "@/data/beachFilters";

const inputCls =
  "w-full rounded-[10px] border border-[#deded9] bg-white px-3 py-2.5 text-[14px] outline-none focus:border-[#171717] transition-colors";
const labelCls = "text-[10px] tracking-[0.14em] uppercase font-black text-[#6d6d6a] mb-1.5 block";

const toText = (v) => (Array.isArray(v) ? v.join(", ") : v || "");
const toLines = (v) => (Array.isArray(v) ? v.join("\n") : v || "");

/** The stored beach lists, from what the editor typed. */
export const beachPayload = (form) => {
  const list = (v) =>
    (Array.isArray(v) ? v.join(", ") : String(v || ""))
      .split(",")
      .map((s) => s.trim())
      .filter(Boolean);
  const lines = (v) =>
    (Array.isArray(v) ? v.join("\n") : String(v || ""))
      .split("\n")
      .map((s) => s.trim())
      .filter(Boolean);
  return {
    beach_activities: list(form.beach_activities),
    beach_nearby_tags: list(form.beach_nearby_tags),
    beach_nearby: lines(form.beach_nearby),
  };
};

/**
 * The beach guide's own half of a listing: where it is, what the water does and
 * what's within reach. A beach is stored like any other place, so these fields
 * sit inside the ordinary listing forms — shown only for the Beach type.
 */
export default function BeachFields({ form, set }) {
  return (
    <div className="space-y-3">
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
        <div>
          <label className={labelCls}>Area</label>
          <input
            className={inputCls}
            value={form.beach_area || ""}
            onChange={(e) => set("beach_area", e.target.value)}
            placeholder="Condado, San Juan"
          />
        </div>
        <div>
          <label className={labelCls}>Region</label>
          <input
            className={inputCls}
            value={form.subcategory || ""}
            onChange={(e) => set("subcategory", e.target.value)}
            placeholder="Metropolitan San Juan"
          />
        </div>
      </div>

      <div>
        <label className={labelCls}>The feel</label>
        <input
          className={inputCls}
          value={form.beach_vibe || ""}
          onChange={(e) => set("beach_vibe", e.target.value)}
          placeholder="Calm, sheltered, family-friendly cove."
        />
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
        <div>
          <label className={labelCls}>Best for</label>
          <input
            className={inputCls}
            value={form.beach_best_for || ""}
            onChange={(e) => set("beach_best_for", e.target.value)}
            placeholder="Families, Paddleboarding"
          />
        </div>
        <div>
          <label className={labelCls}>Water</label>
          <input
            className={inputCls}
            value={form.beach_water || ""}
            onChange={(e) => set("beach_water", e.target.value)}
            placeholder="Very Calm"
          />
        </div>
      </div>

      <div>
        <label className={labelCls}>Water level</label>
        <select
          className={inputCls}
          value={form.beach_water_level || ""}
          onChange={(e) => set("beach_water_level", e.target.value)}
        >
          <option value="">— Not set —</option>
          {WATER_LEVELS.map((level) => (
            <option key={level.value} value={level.value}>
              {level.label}
            </option>
          ))}
        </select>
      </div>

      <div>
        <label className={labelCls}>What you can do here</label>
        <input
          className={inputCls}
          value={toText(form.beach_activities)}
          onChange={(e) => set("beach_activities", e.target.value)}
          placeholder={BEACH_ACTIVITIES.slice(0, 3).join(", ")}
        />
      </div>

      <div>
        <label className={labelCls}>What's nearby</label>
        <input
          className={inputCls}
          value={toText(form.beach_nearby_tags)}
          onChange={(e) => set("beach_nearby_tags", e.target.value)}
          placeholder={BEACH_NEARBY_TAGS.slice(0, 3).join(", ")}
        />
      </div>

      <div>
        <label className={labelCls}>While you're here</label>
        <textarea
          className={inputCls}
          rows={3}
          value={toLines(form.beach_nearby)}
          onChange={(e) => set("beach_nearby", e.target.value)}
          placeholder="Ashford Avenue — Condado's strip of restaurants, bars and boutiques."
        />
      </div>

      <p className="text-[11px] text-[#6d6d6a]">
        Lists are separated by commas; one nearby spot per line, written as Name — note.
      </p>
    </div>
  );
}